// AppPrivacyPolicy.jsx  ->  /app/privacy
//
// Η πολιτική απορρήτου ΤΗΣ ΕΦΑΡΜΟΓΗΣ. Πηγή: docs/PRIVACY.md στο repo
// panellele-app. Αν αλλάξει εκεί, αλλάζει και εδώ.
//
// ── ΓΙΑΤΙ ΔΕΝ ΕΙΝΑΙ ΤΟ /privacy ──────────────────────────────────────────────
// Το /privacy αφορά τον ιστότοπο και δηλώνει Google AdSense, PostHog, cookies
// συγκατάθεσης και Sentry για τον ιστότοπο. Η εφαρμογή δεν έχει διαφημίσεις,
// analytics ή cookies. Δύο προϊόντα, δύο κείμενα.
//
// ΠΡΟΣΟΧΗ: από 2/8/2026 η εφαρμογή έχει **δικό της** Sentry για crash reports.
// Δεν είναι το ίδιο instance με του ιστότοπου και δεν στέλνει τα ίδια δεδομένα:
// μόνο σφάλματα, χωρίς IP και χωρίς αναγνωριστικό χρήστη. Αυτό είναι και ο
// λόγος που το Data Safety form του Play δηλώνει πλέον Crash logs / Diagnostics
// αντί για «δεν συλλέγονται δεδομένα».

import { Link } from 'react-router-dom'
import LegalLayout from './LegalLayout'
import DocumentMeta from './DocumentMeta.jsx'

const LAST_UPDATED = '2 Αυγούστου 2026'
const CONTACT_EMAIL = 'giannisvrn@gmail.com'

export default function AppPrivacyPolicy() {
  return (
    <>
      <DocumentMeta
        title="Πολιτική Απορρήτου Εφαρμογής | Panellele"
        description="Η εφαρμογή Panellele δεν συλλέγει προσωπικά δεδομένα. Χωρίς λογαριασμό, χωρίς διαφημίσεις — τα δεδομένα σου μένουν στο κινητό σου."
        canonical="https://www.panellhniesplus.gr/app/privacy"
      />

      <LegalLayout title="Πολιτική Απορρήτου — Εφαρμογή Panellele">
        <p>
          Τελευταία ενημέρωση: <strong>{LAST_UPDATED}</strong>
        </p>

        <p>
          Η πολιτική αυτή αφορά την <strong>εφαρμογή Panellele</strong> για iPhone και Android. Για
          τον ιστότοπο ισχύει η <Link to="/privacy">ξεχωριστή πολιτική απορρήτου</Link>, επειδή ο
          ιστότοπος —σε αντίθεση με την εφαρμογή— χρησιμοποιεί διαφημίσεις και analytics.
        </p>

        <h2>Με δυο λόγια</h2>
        <p>
          Η εφαρμογή <strong>δεν συλλέγει προσωπικά δεδομένα</strong>. Δεν υπάρχει λογαριασμός, δεν
          υπάρχει εγγραφή, δεν υπάρχουν διαφημίσεις. Ό,τι επιλέγεις μένει στο κινητό σου.
        </p>
        <p>
          Το μόνο που φεύγει από τη συσκευή, πέρα από τα αιτήματα για τα δεδομένα των βάσεων, είναι{' '}
          <strong>αναφορές σφαλμάτων όταν κάτι σπάσει</strong> — τι έσκασε και σε τι συσκευή, χωρίς
          τίποτα που να δείχνει σε εσένα. Αναλυτικά παρακάτω.
        </p>

        <h2>Τι αποθηκεύεται στο κινητό σου</h2>
        <p>
          Τα παρακάτω αποθηκεύονται <strong>τοπικά</strong> και δεν φεύγουν ποτέ από τη συσκευή:
        </p>
        <ul>
          <li>Το επιστημονικό πεδίο και τα ειδικά μαθήματα που δίνεις</li>
          <li>Οι σχολές του μηχανογραφικού σου, με τη σειρά που τις έβαλες</li>
          <li>Τα μόριά σου, αν τα υπολογίσεις ή τα πληκτρολογήσεις</li>
          <li>Οι προτιμήσεις σου για εμφάνιση και ειδοποιήσεις</li>
          <li>Ένα προσωρινό αντίγραφο των βάσεων, ώστε η εφαρμογή να δουλεύει χωρίς σύνδεση</li>
        </ul>
        <p>
          Αν διαγράψεις την εφαρμογή, διαγράφονται όλα μαζί της. Μπορείς επίσης να τα σβήσεις όποτε
          θες από <strong>Ρυθμίσεις → Μηδενισμός δεδομένων</strong>.
        </p>

        <h2>Τι στέλνεται στο δίκτυο</h2>
        <p>
          Η εφαρμογή κάνει αιτήματα <strong>μόνο για ανάγνωση</strong> σε έναν διακομιστή
          (Supabase), για να κατεβάσει:
        </p>
        <ul>
          <li>τις βάσεις εισαγωγής και τα στοιχεία των τμημάτων</li>
          <li>το πρόγραμμα των εξετάσεων</li>
        </ul>
        <p>
          Αυτά τα αιτήματα δεν περιέχουν όνομα, email, αναγνωριστικό συσκευής ή τα μόριά σου. Δεν
          στέλνουμε ποτέ δεδομένα προς αποθήκευση — η εφαρμογή δεν έχει δικαίωμα εγγραφής στη βάση.
        </p>
        <p>
          Όπως κάθε αίτημα στο διαδίκτυο, ο διακομιστής βλέπει τη διεύθυνση IP σου για όσο διαρκεί
          το αίτημα. Δεν τη συνδέουμε με τίποτα και δεν την κρατάμε.
        </p>

        <h2>Αναφορές σφαλμάτων</h2>
        <p>
          Όταν κάτι σπάει μέσα στην εφαρμογή, στέλνεται αυτόματα μια αναφορά σε μια υπηρεσία που
          λέγεται <strong>Sentry</strong>, ώστε να το δούμε και να το διορθώσουμε.
        </p>
        <p>
          Χωρίς αυτό, ο μόνος τρόπος να μάθουμε ότι κάτι χάλασε είναι να το γράψει κάποιος σε email
          — που σημαίνει ότι ένα σφάλμα μπορεί να μείνει εβδομάδες μέσα στην εφαρμογή, μέσα στην
          περίοδο των εξετάσεων.
        </p>
        <p>Τι περιέχει η αναφορά:</p>
        <ul>
          <li>το μήνυμα του σφάλματος και το σημείο του κώδικα όπου συνέβη</li>
          <li>τι έκανε η εφαρμογή λίγο πριν (ποιες οθόνες άνοιξαν, τι αιτήματα έγιναν)</li>
          <li>μοντέλο συσκευής, έκδοση λειτουργικού, έκδοση εφαρμογής</li>
        </ul>
        <p>Τι δεν περιέχει:</p>
        <ul>
          <li>τη διεύθυνση IP σου — αφαιρείται ρητά πριν σταλεί</li>
          <li>οποιοδήποτε αναγνωριστικό χρήστη ή συσκευής· δεν δημιουργείται κανένα</li>
          <li>το πεδίο σου, τους στόχους σου, τους βαθμούς ή τα μόριά σου</li>
          <li>
            μετρήσεις χρήσης ή επιδόσεων από κανονικές συνεδρίες — στέλνεται <strong>μόνο</strong>{' '}
            όταν υπάρχει σφάλμα, ποτέ όταν όλα δουλεύουν
          </li>
        </ul>
        <p>
          Η Sentry επεξεργάζεται τα δεδομένα για λογαριασμό μας ως εκτελών την επεξεργασία και δεν τα
          χρησιμοποιεί για δική της διαφήμιση ή προφίλ. Οι αναφορές αποθηκεύονται στην{' '}
          <strong>ευρωπαϊκή</strong> υποδομή της Sentry και διαγράφονται αυτόματα μετά από 90 ημέρες.
        </p>

        <h2>Ειδοποιήσεις</h2>
        <p>
          Οι υπενθυμίσεις είναι <strong>τοπικές</strong>. Δημιουργούνται στο κινητό σου από
          ημερομηνίες που η εφαρμογή ήδη γνωρίζει. Δεν χρησιμοποιούμε push notifications, δεν
          υπάρχει push token, και κανένας διακομιστής δεν ξέρει ότι έχεις ειδοποιήσεις ανοιχτές.
        </p>
        <p>
          Μπορείς να τις κλείσεις όποτε θες από τις Ρυθμίσεις της εφαρμογής ή του κινητού.
        </p>

        <h2>Analytics και διαφημίσεις</h2>
        <p>
          <strong>Διαφημίσεις:</strong> καμία. Δεν υπάρχει διαφημιστικό δίκτυο μέσα στην εφαρμογή
          και δεν πωλούνται δεδομένα σε κανέναν.
        </p>
        <p>
          <strong>Analytics:</strong> στην τρέχουσα έκδοση δεν υπάρχει. Δεν μετράμε πόσοι ανοίγουν
          την εφαρμογή, ποιες οθόνες βλέπουν ή πόση ώρα μένουν.
        </p>
        <p>
          Το Sentry της προηγούμενης ενότητας δεν είναι analytics: ενεργοποιείται μόνο όταν κάτι
          σπάσει, και η δυνατότητα παρακολούθησης επιδόσεων που προσφέρει είναι απενεργοποιημένη.
        </p>
        <p>
          Αν προστεθούν μετρήσεις χρήσης σε επόμενη έκδοση, θα περιγράφονται εδώ πριν
          ενεργοποιηθούν, με την ημερομηνία στην κορυφή ενημερωμένη.
        </p>

        <h2>Παιδιά</h2>
        <p>
          Η εφαρμογή απευθύνεται σε μαθητές Λυκείου. Επειδή δεν συλλέγει προσωπικά δεδομένα από
          κανέναν, δεν συλλέγει προσωπικά δεδομένα ούτε από ανηλίκους.
        </p>

        <h2>Τα δικαιώματά σου (GDPR)</h2>
        <p>
          Το GDPR σου δίνει δικαίωμα πρόσβασης, διόρθωσης και διαγραφής των προσωπικών σου
          δεδομένων. Επειδή δεν κρατάμε κανένα προσωπικό δεδομένο, δεν υπάρχει κάτι να ζητήσεις ή να
          διαγράψεις από εμάς — τα δεδομένα της εφαρμογής είναι ήδη αποκλειστικά δικά σου, στο
          κινητό σου.
        </p>
        <p>
          Οι αναφορές σφαλμάτων δεν περιέχουν αναγνωριστικό, οπότε δεν υπάρχει τρόπος — ούτε για
          εμάς — να βρούμε ποιες προήλθαν από τη δική σου συσκευή. Αυτό είναι το τίμημα της
          ανωνυμίας: δεν μπορούμε να διαγράψουμε «τα δικά σου» σφάλματα, γιατί δεν ξέρουμε ποια
          είναι. Διαγράφονται ούτως ή άλλως αυτόματα μετά από 90 ημέρες.
        </p>

        <h2>Ακρίβεια δεδομένων</h2>
        <p>
          Οι βάσεις αφορούν προηγούμενα έτη και είναι ενδεικτικές. Οι ημερομηνίες των εξετάσεων, όσο
          δεν έχει βγει το επίσημο ΦΕΚ, είναι <strong>εκτίμηση</strong> και επισημαίνονται ως τέτοια
          μέσα στην εφαρμογή. Ο υπολογισμός μορίων είναι επίσης εκτίμηση, εφόσον οι συντελεστές
          βαρύτητας ορίζονται από κάθε σχολή χωριστά. Μην πάρεις καμία απόφαση για το μηχανογραφικό
          σου βασισμένος αποκλειστικά σε αυτή την εφαρμογή· έλεγξε πάντα τις επίσημες ανακοινώσεις
          του Υπουργείου Παιδείας.
        </p>

        <h2>Αλλαγές</h2>
        <p>
          Αν αλλάξει κάτι σε αυτή την πολιτική, θα ενημερωθεί η ημερομηνία στην κορυφή. Αν ποτέ
          αρχίσουμε να συλλέγουμε προσωπικά δεδομένα — που δεν είναι στα σχέδια — θα ζητηθεί πρώτα η
          συγκατάθεσή σου μέσα στην εφαρμογή.
        </p>

        <h2>Επικοινωνία</h2>
        <p>
          <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
        </p>
        <p>
          Για απορίες σχετικά με τη λειτουργία της εφαρμογής, δες τη{' '}
          <Link to="/app/support">σελίδα υποστήριξης</Link>.
        </p>
      </LegalLayout>
    </>
  )
}
